// extracted by mini-css-extract-plugin
export default {"item":"applications-components-common-Description-contents-module__item"};
    if(module.hot) {
      // 1791528099728
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  